import React from 'react';

import { styles } from './UiKitListCharacteristic.styles';

type Item = { label: React.ReactNode; value: React.ReactNode };

export interface UiKitListCharacteristicProps {
  className?: string;
  items: Item[];
  classNameLabel?: string;
  classNameValue?: string;
}

export function UiKitListCharacteristic({
  className,
  classNameLabel,
  classNameValue,
  items
}: UiKitListCharacteristicProps) {
  const slots = styles();

  return (
    <div className={slots.base({ className })}>
      {items.map((item, index) => (
        <div
          key={index}
          className={slots.item()}
        >
          <div className={slots.label({ className: classNameLabel })}>
            {item.label}
          </div>
          <div className={slots.value({ className: classNameValue })}>
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
}
